import { render, staticRenderFns } from "./InstagramInstantwinAnalyticsPublicCampaign.vue?vue&type=template&id=a2781fdc&scoped=true"
import script from "./InstagramInstantwinAnalyticsPublicCampaign.vue?vue&type=script&lang=ts"
export * from "./InstagramInstantwinAnalyticsPublicCampaign.vue?vue&type=script&lang=ts"
import style0 from "./InstagramInstantwinAnalyticsPublicCampaign.vue?vue&type=style&index=0&id=a2781fdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2781fdc",
  null
  
)

export default component.exports